export default "__VITE_PUBLIC_ASSET__ce3f48b6__"